import { useEffect, useRef } from 'react';

export default function Captcha({ onVerified }) {
    const captchaInstanceRef = useRef(null);

    useEffect(() => {
        const initializeCaptcha = () => {
            if (window.CaptchaSDK) {
                const container = document.getElementById('captcha-container');
                captchaInstanceRef.current = new window.CaptchaSDK({
                    containerId: 'captcha-container',
                    checkboxContainerId: 'captcha-checkbox',
                    modalId: 'captcha-modal',
                    onSuccess: () => {
                        onVerified(true);
                        console.log('CAPTCHA verified successfully');
                    },
                    onFailure: () => {
                        onVerified(false);
                        console.log('CAPTCHA verification failed');
                    },
                    config: {
                        siteKey: '5b7a3fa9-ea3c-4438-a8d3-4bb32c8d6750',
                        compKey: 'cf70da8e-7b25-46b1-8c85-8672d39c45b4'
                    }
                });

                // Prevent click events from bubbling up to the form
                if (container) {
                    container.addEventListener('click', (e) => {
                        e.stopPropagation();
                    });
                }
            }
        };

        initializeCaptcha();

        return () => {
            if (captchaInstanceRef.current) {
                const container = document.getElementById('captcha-container');
                const checkboxContainer = document.getElementById('captcha-checkbox');
                const modal = document.getElementById('captcha-modal');
                if (container) container.innerHTML = '';
                if (checkboxContainer) checkboxContainer.innerHTML = '';
                if (modal) modal.style.display = 'none';
                captchaInstanceRef.current = null;
            }
        };
    }, [onVerified]);

    return (
        <div>
            <div id="captcha-checkbox"></div>
            <div id="captcha-modal" style={{ display: 'none' }}>
                <div id="captcha-container"></div>
            </div>
        </div>
    );
}